<template>
  <div class="container-box">
    <h2 class="title-type-1">캠페인 등록</h2>
    <ul class="progress-step">
      <li class="complete">
        <p class="state">
          <span class="num">1</span>
          <span class="check">
            <v-icon>mdi-check</v-icon>
          </span>
        </p>
        <p class="text">캠페인 정보</p>
      </li>
      <li class="active">
        <p class="state">
          <span class="num">2</span>
        </p>
        <p class="text">캠페인 상품등록</p>
      </li>
    </ul>
    <!-- list-contents -->
    <div class="list-contents">
      <ListContents />
    </div>
    <!--// list-contents -->
  </div>
</template>

<script>
import ListContents from './listContents.vue';

export default {
  components: {
    ListContents,
  },
  data: () => ({}),
  computed: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped></style>
